import React from 'react';
import styles from './PermitsExpandedRow.module.scss';
import CardExpend from '../CardExpend/CardExpend';
import moment from 'moment';
import CommentsBlock from '../CommentsBlock/CommentsBlock';
import DrivingBtn from '../../ui/AddressFilterCard/DrivingBtn/DrivingBtn';
import PermitDocuments from '../PermitDocuments/PermitDocuments';
import { permitConstants } from '../../../../../../constants/permit.constants';
import IntegrationsCard from '../IntegrationsCard/IntegrationsCard';
import CardDate from '../CardDate/CardDate';

const PermitsExpandedRow = ({ record }) => {
  return (
    <div className={styles.root}>
      <div className={styles.firstCol}>
        <PermitDocuments permit={record} />
      </div>
      <div className={styles.rightBlock}>
        <CardExpend
          label="Источник:"
          value={record?.source?.name}
          className={styles.contentFlex}
          style={{ width: 'auto' }}
        />
        <CommentsBlock record={record} className={styles.contentFlex} />
        {!!record?.lineIntegrationInfo?.length && (
          <CardExpend
            label="Интеграция с линия IP:"
            value={<IntegrationsCard data={record?.lineIntegrationInfo} />}
            className={styles.contentFlex}
          />
        )}
        {!!record?.cancellationDate && (
          <CardExpend
            label="Дата аннулирования пропуска:"
            value={moment(record?.cancellationDate)?.format('DD.MM.YYYY')}
            className={styles.contentFlex}
            style={{ width: 'auto' }}
          />
        )}
        {!!record?.entryDate && !!record?.leftDate && (
          <CardDate>
            <CardExpend
              label="Дата въезда:"
              value={moment(record?.entryDate)?.format('DD.MM.YYYY HH:mm')}
              className={styles.contentFlex}
              style={{ width: 'auto' }}
            />
            <CardExpend
              label="Дата выезда:"
              value={moment(record?.leftDate)?.format('DD.MM.YYYY HH:mm')}
              className={styles.contentFlex}
              style={{ width: 'auto' }}
            />
          </CardDate>
        )}
        {record?.permitType?.id === permitConstants.ONE_TIME_PASS && (
          <DrivingBtn record={record} />
        )}
      </div>
    </div>
  );
};

export default PermitsExpandedRow;
